<template>
  <div class="game-health">
    <div class="game-close-btn-wrap">
      <div class="game-close-btn"  @click="closeGamePopup('close')">關閉遊戲</div>
    </div>
    <iframe :src="iframeLink" 
    frameborder="0" width="100%" height="100%"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    gameNumber: {
      type: String,
      required: true,
      default: 184
    }
  },
  data() {
    return {
      // iframeLink:'https://udn.com/game/qa/share/show/issue/184?isApp=true'
    }
  },
  mounted() {},
  methods: {
    closeGamePopup() {
      this.$emit('close-game-popup')
    }
  },
  computed: {
    iframeLink() {
      return `https://udn.com/game/qa/share/show/issue/${this.gameNumber}?isApp=true`
    }
  }
}
</script>

<style scoped>
.game-close-btn-wrap {
  position: relative;
  top: 12px;
  width: 100%;

  height: 36px;
}
.game-close-btn {
  border: 1px solid black;
  text-align: center;
  border-radius: 4px;
  width: 100px;
  margin-left: 8px;
  padding: 4px;
}
.game-close-btn:hover {
  background-color: rgb(94, 94, 94);
  cursor: pointer;
  color: white;
}
.game-health {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #f5f5f5;
  z-index: 100;

}


</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/Moneyudn.vue